export default __webpack_public_path__ + "static/media/insightIcon.69920091.svg";